export default "/images/a34e64e4cf5afa23e8bddd99bab5d3b5.avif";